module.exports = __webpack_public_path__ + "675338d711455c424e7146c828960c90.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-17.png
// module id = 2906
// module chunks = 0